<template>
  <div class="user">
    <i class="el-icon-s-custom personIcon"
       style="margin-right: 5px; margin-top: 2px"></i>
    <el-link v-if="!is_login"
             @click="loginDialogVisible = true">登录</el-link>
    <span class="headText"
          v-if="is_login">{{
      user.nick ? user.nick : user.username
    }}</span>
    <el-dropdown style="margin-left: 12px"
                 v-if="is_login"
                 @command="handleCommand">
      <i class="el-icon-arrow-down headText"
         style="margin-right: 15px"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="loginOut">
          <el-link @click="logout">{{ $t("topHead.login_out") }}</el-link>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible="centerDialogVisible"
               :modal-append-to-body="false"
               width="288px"
               custom-class="phoneDialog"
               center>
      <template v-if="radio == 'phone'">
        <div style="text-align: center">
          {{
            $t("userInfo.enter_phone_title").indexOf("userInfo") == -1
              ? $t("userInfo.enter_phone_title")
              : "手机号验证"
          }}
        </div>
        <div class="phoneBox">
          <div class="enterPhone">
            <el-input :placeholder="
                $t('userInfo.enter_phone_placeholder').indexOf('userInfo') == -1
                  ? $t('userInfo.enter_phone_placeholder')
                  : '请输入手机号'
              "
                      v-model="setting_param.phone"
                      size="mini"
                      ref="phoneEnter" />
          </div>
        </div>
        <div class="codeBox">
          <div>
            <el-input class="code_input"
                      size="mini"
                      type="text"
                      v-model="setting_param.code"
                      :placeholder="
                $t('userInfo.enter_sms').indexOf('userInfo') == -1
                  ? $t('userInfo.enter_sms')
                  : '请输入验证码'
              "></el-input>
          </div>
          <el-button type="text"
                     :disabled="codeDisabled"
                     size="mini"
                     @click="getSmsCode">{{ codeMsg }}</el-button>
        </div>
      </template>
      <template v-else-if="radio == 'mail'">
        <div style="text-align: center">
          {{
            $t("userInfo.enter_email_title").indexOf("userInfo") == -1
              ? $t("userInfo.enter_email_title")
              : "邮箱验证"
          }}
        </div>
        <div class="phoneBox">
          <div class="enterPhone">
            <el-input :placeholder="
                $t('userInfo.enter_email_placeholder').indexOf('userInfo') == -1
                  ? $t('userInfo.enter_email_placeholder')
                  : '请输入邮箱'
              "
                      v-model="setting_param.mail"
                      size="mini"
                      ref="phoneEnter" />
          </div>
        </div>
        <div class="codeBox">
          <div>
            <el-input class="code_input"
                      size="mini"
                      type="text"
                      v-model="setting_param.mail_code"
                      :placeholder="
                $t('userInfo.enter_sms').indexOf('userInfo') == -1
                  ? $t('userInfo.enter_sms')
                  : '请输入验证码'
              "></el-input>
          </div>
          <el-button type="text"
                     :disabled="codeDisabled"
                     size="mini"
                     @click="getSmsCode">{{ codeMsg }}</el-button>
        </div>
      </template>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="mini"
                   @click="goLogin"
                   style="margin-right: 8px">{{
          $t("userInfo.cancel").indexOf("userInfo") == -1
            ? $t("userInfo.cancel")
            : "取消"
        }}</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="verification">{{
          $t("userInfo.verify").indexOf("userInfo") == -1
            ? $t("userInfo.verify")
            : "验证"
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="true"
               :close-on-press-escape="true"
               :show-close="false"
               :visible="codeDialogVisible"
               @close="closeCodeDialog"
               :modal-append-to-body="false"
               width="248px"
               custom-class="phoneDialog"
               center>
      <template>
        <div v-if="radio == 'phone'"
             style="text-align: center; margin-top: 50px">
          手机号码未完成注册
        </div>
        <div v-if="radio == 'mail'"
             style="text-align: center; margin-top: 50px">
          邮箱未完成注册
        </div>
        <div style="text-align: center">请联系数据顾问</div>
        <i class="el-icon-close"
           @click="closeCodeDialog" />
      </template>
      <span slot="footer"
            class="dialog-footer"></span>
    </el-dialog>
    <el-dialog :close-on-click-modal="true"
               :close-on-press-escape="true"
               :show-close="true"
               :visible="loginDialogVisible"
               @close="closeLoginDialog"
               :modal-append-to-body="false"
               width="450px"
               custom-class="login-dialog"
               center>
      <div class="home-page-login-dialog">
        <div class="wechat-desc-title">
          <span class="title">微信扫码登录</span>
        </div>
        <!-- <div class="title-area">
          <span class="title-span"
                style="margin: 20px 0">微信扫码登录</span>
        </div> -->
        <div class="login-area">
          <img :src="qrCode"
               style="width: 180px; height: 180px"
               alt=""
               v-show="!agreementChecked" />
          <wechat-login v-show="agreementChecked"
                        :dialogVisible="loginDialogVisible"
                        @changeScene="changeScene"></wechat-login>
          <div class="login-sub-desc">新用户立得3次免费提问机会！</div>
        </div>
        <div class="footer-area">
          <el-checkbox v-model="agreementChecked">勾选即代表同意
            <el-link href="https://ai.mktindex.com/terms.txt"
                     style="
                height: 20px;
                line-height: 17px;
                color: #a8a8a8;
                font-size: 12px;
                margin-top: -3px;
              "
                     type="primary"
                     target="_blank">镜界AI用户协议</el-link>
            和
            <el-link href="https://ai.mktindex.com/privacy.txt"
                     style="
                height: 18px;
                line-height: 17px;
                color: #a8a8a8;
                font-size: 12px;
                margin-top: -3px;
              "
                     type="primary"
                     target="_blank">镜界AI隐私声明</el-link>
          </el-checkbox>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserInfo,
  smsSendLogin,
  smsVerifyLogin,
  mailSendLogin,
  mailVerifyLogin,
  getAgentLogin,
  postWxMiniLogin,
} from '@/api/user'
import { getPhone } from '@/api/public'
import userflow from 'userflow.js'
import mixpanel from 'mixpanel-browser'
import {
  getObjFromUrl,
  jumpToSelf,
  getBrowserInfo,
  extractShareId,
  isProductionEnvironment,
} from '@/utils'
import WechatLogin from './WechatLogin.vue'
import Cookies from 'js-cookie'

mixpanel.init('de23f732c4e29f1419141f777bcd616f', {
  debug: true,
  track_pageview: false,
  persistence: 'localStorage',
})

//免费版不使用userflow/mixpanel
if (window.location.href.indexOf('radar') < 0) {
  if (
    window.location.href.indexOf('test.mktindex.com') != -1 ||
    window.location.href.indexOf('dev.mktindex.com') != -1
  ) {
    //正式环境为ct_e6r4qjncnze7nktxnkma37ozpi，测试环境为ct_syo72uduzvekjcah5kd5mj5hue
    userflow.init('ct_syo72uduzvekjcah5kd5mj5hue')
  } else {
    userflow.init('ct_e6r4qjncnze7nktxnkma37ozpi')
  }
}
export default {
  components: {
    WechatLogin,
  },
  data() {
    return {
      user: {
        username: '',
        usertype: 'logged_out',
        deadline: '',
        nick: '',
        version: '',
      },
      is_login: false,
      login_url:
        'https://mjlogin.mktindex.com/please_login?service=' +
        window.location.origin +
        '/login&redirect_url=' +
        encodeURIComponent(window.location.href),
      // logout_url:
      //   '/mj_logout?redirect_url=' + encodeURIComponent(window.location.href),
      logout_url: '/mj_logout',
      setting_param: {
        phone_id: '',
        phone: '',
        code: '',
        mail_id: '',
        mail: '',
        mail_code: '',
      },
      options: [],
      phoneOptions: [],
      newArr: [],
      searchText: '',
      centerDialogVisible: false,
      codeDisabled: false,
      countdown: 60,
      codeMsg:
        this.$t('userInfo.get_sms').indexOf('userInfo') == -1
          ? this.$t('userInfo.get_sms')
          : '获取验证码',
      timer: null,

      showMail: false,
      radio: 'phone',
      // mailOptions: [],
      moptions: [],
      codeDialogVisible: false,

      loginDialogVisible: false,
      // 协议同意
      agreementChecked: true,
      qrCode: require('@/assets/qr-code-ma.png'),
      sceneInterval: '',
    }
  },
  methods: {
    logout() {
      mixpanel.reset()
      jumpToSelf(this.logout_url)
      // mixpanel.reset()
    },
    goLogin() {
      window.location.href = this.logout_url
    },
    handleCommand(command) {
      if (command == 'loginOut') {
        sessionStorage.removeItem('hasVerifySetting')
      }
    },
    getSmsCode() {
      if (!this.codeDisabled) {
        this.codeDisabled = true
        let param = {}
        let login
        if (this.radio == 'phone') {
          param = { phone: this.setting_param.phone }
          login = smsSendLogin
        } else if (this.radio == 'mail') {
          param = { mail: this.setting_param.mail }
          login = mailSendLogin
        }

        login(param)
          .then((res) => {
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr()
              this.timer = setInterval(this.getValidStr, 1000)
            }
            if (res.status !== 'ok') {
              this.$message.warning(res.error_msg)
            }
          })
          .catch((e) => {
            if (e.data.status == 'error') {
              if (e.data.error_code == '-497') {
                this.codeDialogVisible = true
              } else {
                this.$message.warning(e.data.error_msg)
              }
            }
            this.codeDisabled = false
          })
          .finally(() => {})
      }
    },
    closeCodeDialog() {
      this.codeDialogVisible = false
    },
    getValidStr() {
      if (this.countdown > 0 && this.countdown <= 60) {
        this.countdown--
        if (this.countdown !== 0) {
          this.codeMsg = this.countdown + 's'
        } else {
          clearInterval(this.timer)
          this.codeMsg = '获取验证码'
          this.countdown = 60
          this.timer = null
          this.codeDisabled = false
        }
      }
    },
    verification() {
      let self = this
      let params = {}
      let verify
      if (this.radio == 'phone') {
        if (this.setting_param.phone == '') {
          this.$message.warning('请选择手机号')
          return
        }
        let active = _.find(this.options, function (o) {
          return o.phone == self.setting_param.phone
        })
        if (active && active.is_login_verify) {
          if (this.setting_param.code == '') {
            this.$message.warning('请输入短信验证码')
            return
          }
        }
        params = {
          phone: this.setting_param.phone,
          code: this.setting_param.code,
        }
        verify = smsVerifyLogin
      } else if (this.radio == 'mail') {
        if (this.setting_param.mail == '') {
          this.$message.warning('请选择邮箱')
          return
        }
        let active = _.find(this.moptions, function (o) {
          return o.mail == self.setting_param.mail
        })
        if (active) {
          if (this.setting_param.mail_code == '') {
            this.$message.warning('请输入邮箱验证码')
            return
          }
        }
        params = {
          mail: this.setting_param.mail,
          code: this.setting_param.mail_code,
        }
        verify = mailVerifyLogin
      }

      verify(params)
        .then((res) => {
          if (res.status == 'ok') {
            location.reload()
          }
        })
        .catch((e) => {
          this.$message.error('验证码错误')
        })
    },
    trackTabChange() {
      document.addEventListener('click', (event) => {
        const target = event.target
        const tabElement = target.closest('[role="tab"]')
        const searchElement = target.closest('.form-search')
        if (tabElement !== null) {
          let tabName = tabElement.innerText
          let tabId = tabElement.getAttribute('id')
          let query = getObjFromUrl(window.location.hash)
          const params = {
            tab_name: tabName,
            url_id: query.url_id,
            start: query.start,
            end: query.end,
            tab_id: tabId,
          }
          mixpanel.track('Tab Change', params)
        } else if (searchElement !== null) {
          const form = document.forms[0]
          const ztreeElement = form.querySelector('.ztree')
          const ztreeId = ztreeElement.getAttribute('id')
          const ztreeObj = $.fn.zTree.getZTreeObj(ztreeId)
          let ignoreIds = []
          const checkNodes = []
          ztreeObj.getCheckedNodes().forEach((item) => {
            // 该节点被全选且父节点未被选中,则子节点id不传入
            if (
              item.check_Child_State == 2 &&
              ignoreIds.indexOf(item.id) == -1
            ) {
              checkNodes.push(item)
              ignoreIds.push(...this.getChdNodesIds(item))
            } // 父节点不是全选,子节点没有children
            else if (
              item.check_Child_State == -1 &&
              ignoreIds.indexOf(item.id) == -1
            ) {
              checkNodes.push(item)
            }
          })
          const map = {}
          map['平台'] = []
          let attrArr = []
          // 遍历表单元素
          for (let i = 0; i < form.elements.length; i++) {
            let element = form.elements[i]
            if (element.type == 'checkbox' && element.checked) {
              const labelElement = this.findNearestLabel(element)
              if (labelElement.innerText.includes('平台')) {
                map['平台'].push(element.value)
              }
            }
            if (element.parentElement.classList.contains('el-input--mini')) {
              const labelElement = this.findNearestLabel(element)
              if (labelElement.innerText.includes('类目')) {
                continue
              }
              if (
                map[labelElement.innerText] &&
                !labelElement.innerText.includes('属性')
              ) {
                map[labelElement.innerText] = [
                  map[labelElement.innerText],
                  element.value,
                ]
              } else if (
                map[labelElement.innerText] &&
                labelElement.innerText.includes('属性')
              ) {
                attrArr.push(element.value)
              } else if (element.value) {
                map[labelElement.innerText] = element.value
              }
            }
          }
          map.cats = checkNodes.map((item) => {
            return item.label
          })
          map['属性'] = {}
          for (let index = 0; index < attrArr.length; index = index + 2) {
            const element = attrArr[index]
            if ((index + 1) % 2 != 0) {
              map['属性'][element] = attrArr[index + 1]
            }
          }
          if (map.cats.length == 0) {
            return
          }
          mixpanel.track('Search Change', map)
        } else {
          return
        }
      })
    },
    getChdNodesIds(nodes) {
      const ids = []
      if (nodes.children && nodes.children.length > 0) {
        nodes.children.forEach((item) => {
          ids.push(item.id)
          if (item.children && item.children.length > 0) {
            ids.push(...this.getChdNodesIds(item))
          }
        })
      }
      return ids
    },
    findNearestLabel(element) {
      var parent = element.parentNode
      let label = null
      while (parent) {
        label = parent.querySelector('.el-form-item__label')

        if (label) {
          return label
        }

        parent = parent.parentNode
      }
    },
    // 用户语言设置
    localLanguage() {
      let language = localStorage.getItem('language')
      // 用户未设置语言
      if (!language) {
        let lang = 'zh'
        if (navigator.language.startsWith('en')) {
          lang = 'en'
          localStorage.setItem('language', lang)
        } else {
          localStorage.setItem('language', lang)
        }
        this.$emit('on-changeLanguage', lang)
      }
    },
    closeLoginDialog() {
      this.loginDialogVisible = false
    },
    changeScene(scene) {
      const browserFinger = localStorage.getItem('browserFinger')
      if (this.sceneInterval) {
        clearInterval(this.sceneInterval)
      }
      this.sceneInterval = setInterval(() => {
        let url = ''
        const currentDomain = window.location.hostname
        if (isProductionEnvironment()) {
          url = 'https://radar.mktindex.com/api/check_agent_login'
        } else {
          url = 'https://radartest.mktindex.com/api/check_agent_login'
        }
        getAgentLogin(url, { scene, browser_finger: browserFinger }).then(
          (res) => {
            if (res.status == 'ok') {
              const result = res.result
              if (result == 2) {
                clearInterval(this.sceneInterval)
                this.sceneInterval = ''
                const browserFinger = localStorage.getItem('browserFinger')
                const browserInfo = getBrowserInfo()
                let property = {
                  $device_id: mixpanel.get_property('$device_id'),
                  $initial_referring_domain: mixpanel.get_property(
                    '$initial_referring_domain'
                  ),
                  $initial_referrer: mixpanel.get_property('$initial_referrer'),
                  browser_id: browserFinger ? browserFinger : '',
                  ...browserInfo,
                }
                postWxMiniLogin({ scene: scene, property: property })
                  .then((res) => {
                    if (res.status == 'ok') {
                      location.reload()
                    } else {
                      this.$message.error(res.error)
                    }
                  })
                  .catch((err) => {})
              }
            }
          }
        )
      }, 300)
    },
  },
  mounted() {
    this.$eventBus.$on('showLoginDialog', () => {
      this.loginDialogVisible = true
    })
  },
  computed: {},
  async created() {
    let that = this
    window.mixpanel = mixpanel
    const browserFinger = localStorage.getItem('browserFinger')
    const phone = localStorage.getItem('phone')
    if (!phone) {
      localStorage.setItem('phone', 'noPhone')
    }
    this.localLanguage()

    getUserInfo()
      .then((res) => {
        if (res.status == 'ok') {
          if (res.result.usertype !== 'logged_out') {
            that.user.username = res.result.username
            that.user.deadline = res.result.deadline
            that.user.nick = res.result.nick
            that.user.usertype = res.result.usertype
            that.is_login = true
            let d = new Date()
            //add userflow event
            let phone = res.result.phone ? res.result.phone : '****'
            let visitorId = res.result.wechat_id
            let origin = window.location.origin
            if (origin.indexOf('lining.com') > 0) {
              this.$sensors.registerPage({
                cem_userName: res.result.username,
                cem_userId: res.result.username_t,
              })
              this.$sensors.setProfile({
                cem_userName: res.result.username,
                cem_userId: res.result.username_t,
              })
            }
            // if (browserFinger) {
            //   //用户名+手机号+浏览器id后五位
            //   visitorId += browserFinger.slice(-5)
            // }

            let lasttag = Cookies.get('from')
            let firstTs = Cookies.get('firstTs')
            let homeFrom = Cookies.get('tagf')
            let homeTs = Cookies.get('tagfTs')
            // 如果用户通过f=zhihu_if进入，即from记为zhihu_if。如果用户直接通过无后缀的域名访问，则from记为0。如果用户从来没有访问过镜界，则from记为空。
            let query = getObjFromUrl(window.location.hash)
            let agent_from = ''
            if (lasttag) {
              agent_from = lasttag
            } else if (query.f && !lasttag) {
              agent_from = query.f
            } else if (!query.f && !lasttag) {
              // 从来没访问过
              agent_from = ''
            } else {
              // 无后缀访问
              agent_from = 0
            }
            if (res.result.agent_from) {
              agent_from = res.result.agent_from
            }
            let infoObj = {
              ...res.result,
              ai_totaltime: res.result.ai_totaltime
                ? res.result.ai_totaltime
                : '',
              browser_fingerprint: browserFinger ? browserFinger : '', // 浏览器id
              name: visitorId,
              account: res.result.username ? res.result.username : '',
              agent_from,
              ai_from: agent_from,
              ai_ts: firstTs,
              home_from: homeFrom,
              home_ts: homeTs,
            }
            //only collocate chrome browser now.
            infoObj = Object.assign(infoObj, res.result.attribute)
            //免费版不使用userflow/mixpanel
            if (
              browserFinger &&
              window.location.href.indexOf('radar') < 0 &&
              res.result.username != 'screenshot'
            ) {
              const current_distinct_id = mixpanel.get_distinct_id()
              if (current_distinct_id !== visitorId) {
                mixpanel.identify(visitorId)
              }
              if (
                window.location.href.indexOf('test.mktindex.com') != -1 ||
                window.location.href.indexOf('dev.mktindex.com') != -1
              ) {
                //if (res.result.username.endsWith('@moojing.com')) {
                // userflow.identify(visitorId, infoObj)
                mixpanel.identify(visitorId)
                mixpanel.people.set(infoObj)
                //}
              } else if (window.location.href.indexOf('mktindex.com') != -1) {
                // userflow.identify(visitorId, infoObj)
                mixpanel.identify(visitorId)
                mixpanel.people.set(infoObj)
              }
            }
            this.trackTabChange()
            that.$emit('userLogin', res.result)
            if (res.result.agent_from.indexOf('jdjm') > -1) {
              // if (true) {
              this.$store.dispatch('user/changeIsJdUser', true)
            } else {
              this.$store.dispatch('user/changeIsJdUser', false)
            }
          } else {
            const query = getObjFromUrl(window.location.hash)
            const share_id = extractShareId(query)
            if (!share_id) {
              this.$eventBus.$emit('showHomeDialog')
            }
            //for oem proxy_pass goto oem login url
            if (res.result.not_allow) {
              this.$message.error('您没有权限访问此系统，请联系管理员!')
            }
            var origin = window.location.origin
            if (origin.indexOf('mktindex') < 0) {
              if (origin.indexOf('lining.com') != -1) {
                d = new Date().getTime()
                window.location.href =
                  'https://sso.lining.com/esc-sso/oauth2.0/authorize?client_id=pBKuYWBH0j&redirect_uri=' +
                  origin +
                  '/api/sso_callback&response_type=code&target_uri=' +
                  origin +
                  '/dashboard&oauth_timestamp=' +
                  d
              } else {
                window.location.href = window.location.origin + '/login'
              }
            } else {
              // window.location.href = that.login_url
            }
          }
          mixpanel.track(
            'Page View',
            {
              page_name: window.location.pathname,
            },
            () => {
              // 回调函数，页面浏览事件完成后执行
              if (!res.result.phone) {
                localStorage.setItem('phone', 'noPhone')
              } else {
                if (
                  localStorage.getItem('phone') == 'noPhone' &&
                  res.result.phone
                ) {
                  localStorage.setItem('phone', res.result.phone)
                  setTimeout(() => {
                    mixpanel.track('Get Phone', {
                      source: 'ai',
                      url: window.location.host,
                    })
                  }, 10000)
                }
              }
            }
          )
        }
      })
      .catch((e) => {
        mixpanel.track(
          'Page View',
          {
            page_name: window.location.pathname,
          },
          function () {}
        )
        if (e.data.status == 'error' && e.data.error_code == -499) {
          getPhone()
            .then((res) => {
              if (res.status == 'ok') {
                // if (res.result.length > 0) {
                //   this.setting_param.phone_id = res.result[0].phone_id
                //   this.setting_param.phone = res.result[0].phone
                // }
                this.options = res.result
                this.phoneOptions = res.result
              }
              this.centerDialogVisible = true
            })
            .catch((e) => {})
        } else if (e.data.status == 'error') {
          /**
           * e = {
           *  data: {
           *    error_msg: {
           *      msg: "",
           *      msg_en: ""
           *    }
           *  }
           * }
           */
          this.$message.error(e.data.error_msg.msg)
        }
      })
      .finally(() => {})
  },
}
</script>
<style lang="less">
.user {
  /deep/ .phoneDialog {
    .phoneBox {
      display: flex;
      padding-left: 24px;
      margin: 16px 0 12px;
      // .selectPhone {
      //   margin-right: 12px;
      // }
      .enterPhone {
        width: inherit;
        .el-input__inner {
          width: 240px;
          height: 28px;
          border: 1px solid #ccc;
        }
      }
      // .search_input {
      //   .el-input__inner {
      //     width: 100px;
      //   }
      // }
    }
    .codeBox {
      display: flex;
      padding: 0 24px;
      .code_input {
        margin-right: 12px;
        .el-input__inner {
          width: 128px;
          height: 28px;
          border: 1px solid #ccc;
        }
      }
    }
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 24px 0 55px !important;
    }
    .el-dialog__footer {
      padding-bottom: 24px;
    }
    .el-icon-close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
  }
}
.login-dialog {
  .el-dialog__body {
    border-radius: 25px;
  }
  .home-page-login-dialog {
    width: 100%;

    .wechat-desc-title {
      font-size: 20px;
      font-weight: bolder;
      text-align: center;
      color: #2d2d2d;
      font-family: inherit;
      letter-spacing: 2px;
      margin-bottom: 20px;
      margin-top: 20px;
      .title {
        display: inline-block;
        padding-bottom: 5px;
        border-bottom: 2px solid #2d2d2d;
      }
    }
    .title-area {
      .title-span {
        font-size: 16px;
        font-weight: bolder;
        margin: 0;
        padding: 0;
        line-height: 25px;
        margin: 20px 0;
      }
    }
    .login-area {
      width: 100%;
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 10px;
      .login-sub-desc {
        color: #2f4eff;
        font-size: 16px;
        margin-top: 15px;
        font-weight: bold;
      }
    }
    .footer-area {
      text-align: center;
      margin-top: 30px;
      font-size: 12px;
      color: #a8a8a8;
    }
  }
}
</style>
<style lang="less">
.home-page-login-dialog {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #a8a8a8;
    font-size: 12px;
  }
  .el-checkbox__label {
    color: #a8a8a8;
    font-size: 12px;
  }
}
.login-dialog {
  border-radius: 25px !important;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    border-radius: 25px !important;
    .el-dialog--center .el-dialog__body {
      padding: 0;
    }
  }
  .el-icon-close:before {
    background-color: #e0e0e0;
    border-radius: 50%;
    color: white;
  }
}
</style>
